import React from "react";
import { Route, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { loadUser } from "../actions/authActions";

const PublicRoute = ({
  component: Component,
  auth: { isAuthenticated, loading },

  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => isAuthenticated === false && <Component {...props} />}
  />
);

PublicRoute.propTypes = {
  auth: PropTypes.object.isRequired,
  subscription: PropTypes.object.isRequired,
};

const mapSateToProps = (state) => ({
  auth: state.auth,
  subscription: state.subscription,
});
export default connect(mapSateToProps)(PublicRoute);
